import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import BoardOfDirectors from "./pages/BoardOfDirectors";
import MissionVision from "./pages/MissionVision";
import QualityPolicy from "./pages/QualityPolicy";
import HumanResources from "./pages/HumanResources";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import ProjectDetail from "./pages/ProjectDetail";
import ScrollToTop from "./components/ScrollToTop";

// Admin
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./components/layout/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminNews from "./pages/admin/AdminNews";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminContact from "./pages/admin/AdminContact";
import AdminHR from "./pages/admin/AdminHR";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Website */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="kurumsal">
              <Route index element={<Navigate to="hakkimizda" replace />} />
              <Route path="hakkimizda" element={<About />} />
              <Route path="yonetim-kurulu" element={<BoardOfDirectors />} />
              <Route path="misyon-vizyon" element={<MissionVision />} />
              <Route path="kalite-politikasi" element={<QualityPolicy />} />
              <Route path="insan-kaynaklari" element={<HumanResources />} />
            </Route>
            <Route path="haberler">
              <Route index element={<News />} />
              <Route path=":id" element={<NewsDetail />} />
            </Route>
            <Route path="proje" element={<ProjectDetail />} />
            <Route path="galeri" element={<Gallery />} />
            <Route path="iletisim" element={<Contact />} />
          </Route>

          {/* Admin Panel */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="contact" element={<AdminContact />} />
            <Route path="hr" element={<AdminHR />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
